import * as React from "react";
import { GooSpinner } from "react-spinners-kit";

const StoreContextLoader = () => {
  return (
    <React.Fragment>
      <div
        style={{
          height: "100vh",
          width: "100vw",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <GooSpinner color="#fc0f03" size={60} loading />
      </div>
    </React.Fragment>
  );
};

export default StoreContextLoader;
